import cn from "classnames"

import { Card } from "./components"
import style from "./style.module.scss"
import { FAQContainer } from "./components/FAQContainer"
import { getMaxHeightLabels } from "./helpers/getMaxHeightLabels"

import { PSYCHOLOGIST_COUNT } from "utils/env-management"
import { Psychologist } from "utils/interfaces"
import { NobodyLikedCard } from "modules/SelectionOfPsychologists/components"

interface Props {
    profiles: Psychologist[]
    freeBooking?: boolean
    className?: string
    showMorePsyCard?: boolean
    showPsysStory?: number
}

export function Cards({
    profiles,
    className,
    freeBooking = false,
    showMorePsyCard = true,
    showPsysStory,
}: Props) {
    const labelsBlockMaxHeight = getMaxHeightLabels(profiles)

    return (
        <div className={cn(style.container, className)}>
            <div className="columns is-multiline">
                {profiles.map((psy, index) => (
                    <div key={index} className="column is-6-tablet is-4-desktop is-flex">
                        <Card
                            labelsBlockMaxHeight={labelsBlockMaxHeight}
                            psy={psy}
                            index={`${index + 1}`}
                            freeBooking={freeBooking}
                            showPsysStory={showPsysStory}
                        />
                    </div>
                ))}
                {!freeBooking && showMorePsyCard && (
                    <div className="column is-6-tablet is-4-desktop is-flex">
                        <NobodyLikedCard
                            headline="Каталог психологов"
                            secondary={`Больше ${PSYCHOLOGIST_COUNT} других проверенных психологов Alter.`}
                        />
                    </div>
                )}
            </div>
            <FAQContainer />
        </div>
    )
}
